export type IdentifyAttributes = {
  email: string
}

export const identify = (id: string, attributes: IdentifyAttributes) => {
  analytics.identify(id, attributes)
}
